module.exports = __webpack_public_path__ + "static/sui-button-group-equal-width-1fb5cf9ef485ea58f596bc9297287fe9.png";